import PropTypes from 'prop-types'; // @mui
import {useTheme} from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
// hooks
import {useResponsive} from 'packages/common/hooks/useResponsive';
import {useAdminBannerOffset} from 'packages/common/hooks/useAdminBannerOffset';
// theme
import {bgBlur} from 'packages/common/theme/css';
// components
import Iconify from 'packages/common/components/iconify';
import {useSettingsContext} from 'packages/common/components/settings';
//
import {NAV, SAFE_AREA_TOP} from '../config-layout';

// ----------------------------------------------------------------------

export default function NavToggleButton({sx, ...other}) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const adminBannerOffset = useAdminBannerOffset();

  if (!lgUp) {
    return null;
  }

  return (
    <IconButton
      size="small"
      onClick={() =>
        settings.onUpdate('themeLayout', settings.themeLayout === 'vertical' ? 'mini' : 'vertical')
      }
      sx={{
        'p': 0.5,
        // Aligné sur le logo du menu, qui descend du retrait haut en PWA iOS.
        'top': `calc(${32 + adminBannerOffset}px + ${SAFE_AREA_TOP})`,
        'position': 'fixed',
        'left': NAV.W_VERTICAL - 12,
        'zIndex': theme.zIndex.appBar + 1,
        'border': `dashed 1px ${theme.palette.divider}`,
        ...bgBlur({opacity: 0.48, color: theme.palette.background.default}),
        '&:hover': {
          bgcolor: 'background.default',
        },
        ...sx,
      }}
      {...other}
    >
      <Iconify
        width={16}
        icon={
          settings.themeLayout === 'vertical' ?
            'eva:arrow-ios-back-fill' :
            'eva:arrow-ios-forward-fill'
        }
      />
    </IconButton>
  );
}

NavToggleButton.propTypes = {
  sx: PropTypes.object,
};
